var locale = {
    placeholder: '请选择时间'
};
export default locale;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/time-picker/locale/zh_CN.js
// module id = 470
// module chunks = 0